import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import ChangePasswordPage from '@/settings/pages/change-password';

export const Route = createFileRoute('/settings/_layout/user-profile/change-password')({
  head: () => ({
    meta: routeMetadata('Change Password')
  }),
  component: ChangePasswordRoute,
  staticData: {
    headerSection: null
  }
});

function ChangePasswordRoute() {
  return <ChangePasswordPage/>;
}
